var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home"},[_c('div',{staticClass:"titlePage"},[_vm._v(_vm._s(this.$route.params.Area))]),_c('ShortPresen',{attrs:{"InfoView":this.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }